import i18next from 'i18next';
import { memo, useCallback, useId } from 'react';

import { selectedType } from '../../../../store/appointment-type';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import {
  closeMultiStorePanel,
  openMultiStorePanel,
  selectedIsMultiStorePanelOpen,
  startMultiStore,
} from '../../../../store/multi-store';
import { selectedPointOfSale } from '../../../../store/point-of-sale';
import { MultiStorePanel } from './multi-store-panel';
import { MultiStoreRecapRow } from './multi-store-recap-row';
import { trackMultiStorePanelOpened } from './multi-store-tracking';
import { useMultiStoreCandidates } from './use-multi-store';

// Sotto il calendario classico, solo se l'insegna ha centri alternativi per il servizio:
// invito a cercare anche negli altri centri. «Scegli i centri» fissa l'origin al primo
// utilizzo e apre il pannello subito sotto la riga.
export const MultiStoreEntry = memo(
  function MultiStoreEntry(): JSX.Element | null {
    const dispatch = useAppDispatch();
    const { data } = useMultiStoreCandidates();
    const current = useAppSelector(selectedPointOfSale);
    const { id: serviceId } = useAppSelector(selectedType);
    const isPanelOpen = useAppSelector(selectedIsMultiStorePanelOpen);
    const panelId = useId();

    const handleToggle = useCallback(() => {
      if (isPanelOpen) {
        dispatch(closeMultiStorePanel());
        return;
      }
      dispatch(startMultiStore({ pointOfSale: current, serviceId }));
      dispatch(openMultiStorePanel());
      trackMultiStorePanelOpened();
    }, [current, dispatch, isPanelOpen, serviceId]);

    if (data === undefined || data.length === 0) return null;

    return (
      <div className="multi-store-section multi-store-section-classic">
        <MultiStoreRecapRow
          text={i18next.t('pages.when.multi_store.entry')}
          actionText={i18next.t('pages.when.multi_store.entry_action')}
          isExpanded={isPanelOpen}
          panelId={panelId}
          onAction={handleToggle}
        />
        {isPanelOpen && <MultiStorePanel id={panelId} />}
      </div>
    );
  }
);
